// Import Packages
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// Import Material UI
import Grid from "@material-ui/core/Grid";
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CreateConnector from "../../../../../home/pages/appCredential/appCredentialProcess/AppCredentialProcess";
import { CircularProgress } from "@material-ui/core";
import DoneIcon from '@material-ui/icons/Done';
import Divider from "@material-ui/core/Divider";

// Import Pages
import ApplicationService from "../../../../../services/ApplicationService/ApplicationService";
import Search from "../../../../Search/Search";

// Import CSS
import './Connector.css';


export default function Connector({
    selectedApp,
    appCredentials,
    setAppCredentials,
    selectedConnectorId,
    handleSetSelectedConnector
}) {
    const [searchData, setSearchData] = useState([])
    const [refreshCredentials, setRefreshCredentials] = useState("");
    const [progressStatus, setProgressStatus] = useState(true);
    const [showCreateConnector, setShowCreateConnector] = useState(false);
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.TRIGGER-STATIC.CONNECTORS."
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        GetAppCredentials().then(r => r);
    }, [refreshCredentials]);

    async function GetAppCredentials() {
        setLoading(true);
        const response = await ApplicationService.getAppCredentials({ application_id: selectedApp.id });
        if (response && response.status && response.data.length) {
            const data = response.data;
            setAppCredentials(data);
            setSearchData(data);
        }
        setLoading(false);
    }

    const handleCreateConnector = () => {
        setTimeout(function () {
            setProgressStatus(false);
        }, 500);
        setShowCreateConnector(true)
    }

    return (
        <>
            {!showCreateConnector && appCredentials && appCredentials.length > 0 && (
                <div className="form-element search-element margin-zero">
                    <Search data={appCredentials} setSearchData={setSearchData} xs={11} sm={11} md={11} lg={11}
                        spacing={2}
                        customClasses={['trigger-search']}
                        searchKey={['name']} />
                </div>
            )}
            <div className={`${!showCreateConnector && appCredentials && appCredentials.length > 0 ? 'apps-container' : 'trigger-connector-container'} `}>
                {showCreateConnector ? (
                    <>
                        <Grid container spacing={3} className="connector-grid-container">
                            <div className="create-connector-container">
                                <Grid item xs={12} sm={12} md={12}
                                    className="visible">
                                    {progressStatus ? (
                                        <div className="progress-loader">
                                            <CircularProgress />
                                            <span>{t('CONTENT.AUTH-PAGES.LOADING')}</span>
                                        </div>
                                    ) : (
                                        <CreateConnector inputColor={"#fcfcfc"} selectedApp={selectedApp} showCancelButton={false}
                                            setShowCreateConnector={setShowCreateConnector}
                                            setRefreshCredentials={setRefreshCredentials} />
                                    )}

                                </Grid>
                            </div>
                        </Grid>
                    </>
                ) : (
                    <div className="trigger-connectors">
                        {searchData?.length > 0 && searchData?.map((item, i) => (
                            <Grid container spacing={3} className="connector-grid-container" key={i}>

                                <Grid item xs={12} sm={12} md={12}
                                    className="visible">
                                    <div className="connector-container">

                                        <div
                                            className={`connector-item ${selectedConnectorId === item.id ? 'selected' : ''}`}
                                            onClick={() => handleSetSelectedConnector(item)}>
                                            <div
                                                className={`connector-icon connector-${item.name.replace(' ', '-').toLowerCase()} ${selectedConnectorId === item.id ? 'selected' : ''}`}
                                            >

                                                <VpnKeyIcon />
                                                <DoneIcon className={`${selectedConnectorId === item.id ? 'trigger-done-icon top-position' : 'hidden'}`} alignmentBaseline="central" />
                                            </div>
                                            <span>{item.name}</span>
                                        </div>
                                    </div>
                                </Grid>


                            </Grid>
                        ))}
                        {
                            !loading && <Grid justifyContent="center" alignItems={appCredentials.length > 0 ? 'flex-end' : 'center'} container direction="row" className="connector-grid-container container-full-heigth">
                                <Grid item xs={12} sm={12} md={searchData?.length > 0 ? 12 : 6}
                                    className="visible">
                                    <div className="create-pane" onClick={handleCreateConnector}>
                                        <button type="button">{t(label + "CREATE-CONNECTOR")}</button>
                                    </div>
                                </Grid>
                            </Grid>
                        }
                    </div >
                )}
            </div>
        </>

    )
}
